import { render, staticRenderFns } from "./UserDisabled.vue?vue&type=template&id=5b0bddce&scoped=true"
import script from "./UserDisabled.vue?vue&type=script&lang=js"
export * from "./UserDisabled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0bddce",
  null
  
)

export default component.exports